import React, { useContext, useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Drawer,
  ListItemIcon,
  Icon,
  makeStyles,
  Box,
  Collapse,
  Typography,
  Divider
} from "@material-ui/core";
import { NavLink, Link } from "react-router-dom";
import darklogo from "../../assets/images/darklogo.svg";
import logo from "../../assets/images/health2.svg";
import small from "../../assets/images/small.svg";
import logo2 from "../../assets/images/logo2.png";
import { ThemeContext } from "../../App";


const Sidebar = (props) => {
  const { mode } = useContext(ThemeContext);
  const logos = mode === "light" ? logo : darklogo;
  const Smalls = mode === "light" ? logo2 : small;
  const useStyles = makeStyles((theme) => ({
    drawer: {
      width: 240,
      flexShrink: 0,
      borderRight: "none",
      transition: "width 0.3s ease",
      overflowX: "hidden",
      "&.collapsed": {
        width: 72,
        "& $menuText, & $organizationText": {
          opacity: 0,
          width: 0
        },
        "& $expandIcon": {
          display: "none"
        },
        "& $logoText": {
          opacity: 0
        }
      }
    },
    drawerPaper: {
      width: 240,
      transition: "width 0.3s ease",
      overflowX: "hidden",
      borderRight: "1px solid #787575c3",
      backgroundColor: theme.palette.background.drawer,
      "&.collapsed": {
        width: 72
      }
    },
    logoContainer: {
      padding: "20px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      borderBottom: "1px solid #787575c3"
    },
    logoText: {
      marginTop: 8,
      fontWeight: 600,
      color: "#1976d2",
      transition: "opacity 0.3s ease",
      whiteSpace: "nowrap"
    },
    userContainer: {
      padding: "16px",
      borderBottom: "1px solid #e0e0e0"
    },
    organizationText: {
      fontWeight: 500,
      color: "#424242",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textAlign: "center",
      transition: "all 0.3s ease"
    },
    listItem: {
      margin: "4px 8px",
      borderRadius: 8,
      paddingLeft: 12,
      paddingRight: 12,
      "&:hover": {
        backgroundColor: theme.palette.type === "light" ? "#eef2fbff" : "#494e55",
      }
    },
    listItemIcon: {
      minWidth: 36,
      color: theme.palette.listItem,
      transition: "all 0.2s ease"
    },
    menuText: {
      color: theme.palette.listItem,
      fontWeight: 500,
      fontSize: "0.875rem",
      transition: "all 0.3s ease"
    },
    navLink: {
      display: "block",
      textDecoration: "none",
      "&.active": {
        "& $listItem": {
          backgroundColor: mode === "light" ? "#eceff4" : "#494e55",
          "& $listItemIcon": {
            color: mode === "light" ? "black" : "white",
          },
          "& $menuText": {
            color: mode === "light" ? "black" : "white",
          }
        }
      }
    },
    subMenu: {
      marginLeft: 24,
      overflow: "hidden"
    },
    subMenuItem: {
      margin: "2px 0",
      borderRadius: 6,
      paddingLeft: 12,
      "&:hover": {
        backgroundColor: "#e3f2fd"
      }
    },
    expandIcon: {
      color: "#5f6368",
      transition: "all 0.2s ease"
    },
    menuToggle: {
      position: "absolute",
      top: 7,
      right: 10,
      cursor: "pointer",
      color: "#5f6368",
      "&:hover": {
        color: "#1976d2"
      }
    },
    activeExpandIcon: {
      transform: "rotate(180deg)",
      color: "#1976d2"
    },
    divider: {
      margin: "8px 16px",
      backgroundColor: "#e0e0e0"
    }
  }));
  const { routes } = props;
  const classes = useStyles();
  const [url, setUrl] = useState("");
  const [expandedMenus, setExpandedMenus] = useState({});
  const [collapsed, setCollapsed] = useState(false);

  let authAdmin = localStorage.getItem("admin");
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  authAdmin = loginUserInfo.role === "SUPERADMIN" ? false : true;

  const getAuthLogin = loginUserInfo.role;

  useEffect(() => {
    if (getAuthLogin.toLowerCase() === "organization") {
      setUrl("admin");
    } else if (getAuthLogin.toLowerCase() === "superadmin") {
      setUrl("super-admin");
    } else {
      setUrl("staff");
    }
  }, [getAuthLogin]);

  const handleStorageData = () => {
    localStorage.setItem("tabStatus", 0);
    localStorage.setItem("pageNo", 1);
  };

  const toggleMenu = (menuName) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuName]: !prev[menuName]
    }));
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
    props.custom_fullwindow();
  };
  console.log(routes, "routes in sidebar");
  return (
    <Drawer
      variant="permanent"
      className={`${classes.drawer} ${collapsed ? "collapsed" : ""}`}
      classes={{
        paper: `${classes.drawerPaper} ${collapsed ? "collapsed" : ""}`
      }}
    >
      <Box className={classes.logoContainer}>
        <Link
          to={!authAdmin ? "/super-admin/dashboard" : "/admin/bookings"}
          className="logo"
        >
          {collapsed ? <img src={logo2} alt="Pluto logo" height={60} /> : <img src={logo} alt="Pluto logo" height={60} />}

        </Link>
        <Icon
          className={classes.menuToggle}
          onClick={toggleCollapse}
        >
          {collapsed ? "chevron_right" : "chevron_left"}
        </Icon>
      </Box>

      {/* <Box className={classes.userContainer}>
        <Typography variant="body2" className={classes.organizationText}>
          {loginUserInfo.organization_name || 
           `${loginUserInfo?.first_name} ${loginUserInfo?.last_name}`}
        </Typography>
      </Box> */}

      {/* <Divider className={classes.divider} /> */}

      <List>
        {routes
          // .filter(
          //   (route) =>
          //     route.role.split(",").includes(getAuthLogin.toLowerCase()) &&
          //     route.sidebar !== false
          // )
          .filter(
            (route) => {
              let dashboardShown = false;
              const hasRole = route.role.split(",").includes(getAuthLogin.toLowerCase());
              const routeKey = route.path.replace(/^\//, "").toLowerCase();
              if (loginUserInfo?.role === "STAFF") {
                if (routeKey === "dashboard") {
                  return hasRole && route.sidebar !== false;
                }

                return (
                  hasRole &&
                  loginUserInfo?.permissions?.map(p => p.toLowerCase()).includes(routeKey) &&
                  route.sidebar !== false
                );
              }
              return hasRole && route.sidebar !== false;
            })
          .map((route, index) => {
            const hasChildren = route.child && route.child.length > 0;
            const isMenuExpanded = expandedMenus[route.name] || false;
            return (
              <React.Fragment key={index}>
                {!hasChildren ? (
                  <NavLink
                    to={`/${url}/${route.path}`}
                    className={classes.navLink}
                    activeClassName="active"
                    onClick={handleStorageData}
                    exact
                  >
                    <ListItem className={classes.listItem} button>
                      <ListItemIcon className={classes.listItemIcon}>
                        {/* <Icon>{route.icon}</Icon> */}
                        {route.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={route.name === "Compliance-document"
                          ? "Compliance Docs"
                          : route.name}
                        classes={{ primary: classes.menuText }}
                      />
                    </ListItem>
                  </NavLink>
                ) : (
                  <React.Fragment>
                    <ListItem
                      className={classes.listItem}
                      button
                      onClick={() => toggleMenu(route.name)}
                    >
                      <ListItemIcon className={classes.listItemIcon}>
                        <Icon>{route.icon}</Icon>
                      </ListItemIcon>
                      <ListItemText
                        primary={route.name}
                        classes={{ primary: classes.menuText }}
                      />
                      <Icon
                        className={`${classes.expandIcon} ${isMenuExpanded ? classes.activeExpandIcon : ""
                          }`}
                      >
                        {isMenuExpanded ? "expand_less" : "expand_more"}
                      </Icon>
                    </ListItem>

                    <Collapse in={isMenuExpanded} timeout="auto" unmountOnExit>
                      <Box className={classes.subMenu}>
                        {route.child
                          .filter(
                            (route) => {
                              console.log(route, "route " + route?.role, "role");
                              const hasRole = route.role.split(",").includes(getAuthLogin.toLowerCase());
                              const routeKey = route.path.replace(/^\//, "").toLowerCase();
                              console.log(routeKey, "routeKey" + loginUserInfo?.permissions?.map(p => p.toLowerCase()).includes(routeKey));
                              if (loginUserInfo?.role === "STAFF") {
                                return (
                                  hasRole &&
                                  loginUserInfo?.permissions?.map(p => p.toLowerCase()).includes(routeKey) &&
                                  route.sidebar !== false
                                );
                              }
                              return hasRole && route.sidebar !== false;
                            })
                          // .filter(item => item.sidebar !== false)
                          .map((item, key) => (
                            <NavLink
                              to={`/${url}/${item.path}`}
                              className={classes.navLink}
                              activeClassName="active"
                              key={key}
                              onClick={handleStorageData}
                            >
                              <ListItem className={classes.listItem} button>
                                <ListItemIcon className={classes.listItemIcon}>
                                  <Icon>{item.icon}</Icon>
                                </ListItemIcon>
                                <ListItemText
                                  primary={
                                    item.name === "Invoice-Studio"
                                      ? "Invoicing Studio"
                                      : item.name
                                  }
                                  classes={{ primary: classes.menuText }}
                                />
                              </ListItem>
                            </NavLink>
                          ))}
                      </Box>
                    </Collapse>
                  </React.Fragment>
                )}
              </React.Fragment>
            );
          })}
      </List>
    </Drawer>
  );
};

export default Sidebar;